<template>
  <div>
    <el-dialog :visible.sync="visible" width="400px" :center="false">
      <div slot="title" class="title-container"><span>Edit Date</span></div>
      <el-form ref="form-date" label-width="120px">
        <el-form-item label="Date">
          <el-date-picker
            v-model="tDate"
            type="date"
            format="dd MMM yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Choose Sheet Date"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-if="etaDateShow" label="ETA Date">
          <el-date-picker
            v-model="tDeliveryDate"
            type="date"
            format="dd MMM yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Choose ETA Date"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-if="dispatchDateShow" label="Dispatch Date">
          <el-date-picker
            v-model="tDeliveryDate"
            type="date"
            format="dd MMM yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Choose Dispatch Date"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-if="pickupDateShow" label="Pickup Date">
          <el-date-picker
            v-model="tDeliveryDate"
            type="date"
            format="dd MMM yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Choose Pickup Date"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-if="dueDateShow" label="Due Date">
          <el-date-picker
            v-model="tDueDate"
            type="date"
            format="dd MMM yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Choose Due Date"
            size="mini"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible">Cancel</el-button>
        <el-button size="mini" type="primary" @click="handleSubmit">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderDateModify } from '../api'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogDate',
  computed: {
    visible: {
      get () {
        return this.dialogVisible
      },
      set (val) {
        this.$emit('closed')
      }
    },
    ...mapState('edit', ['id', 'type', 'date', 'dueDate', 'deliveryDate']),
    dueDateShow () {
      return this.type === 1 || this.type === 2 || this.type === 4 || this.type === 5
    },
    etaDateShow () {
      return this.type === 3
    },
    dispatchDateShow () {
      return this.type === 1
    },
    pickupDateShow () {
      return this.type === 2
    }
  },
  data () {
    return {
      tDate: '',
      tDueDate: '',
      tDeliveryDate: ''
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions({
      reload: 'edit/loadOrder'
    }),
    async handleSubmit () {
      await orderDateModify(this.id, { date: this.tDate, dueDate: this.tDueDate, deliveryDate: this.tDeliveryDate })
      this.$message({
        message: 'Operation successful',
        type: 'success'
      })

      this.reload(this.id)
      this.$emit('closed')
    },
    dialogFormVisible () {
      this.tDate = this.date
      this.tDueDate = this.dueDate
      this.tDeliveryDate = this.deliveryDate
      this.$emit('closed')
    }
  },
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.tDate = this.date
        this.tDueDate = this.dueDate
        this.tDeliveryDate = this.deliveryDate
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  color: #000;
  line-height: 48px;
  padding: 0 60px 0 20px;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
</style>
